(function (app) {

    app.provider("reportsApi", [function () {
        this.$get = [
            "portalApiGateway", function (portalApiGateway) {
                var service = {};
                service.getPendingPolicies = function (lob) {
                    return portalApiGateway.getArray("/PolicyReport/" + lob + "/Pending");
                };
                service.getInforcePolicies = function (lob) {
                    return portalApiGateway.getArray("/PolicyReport/" + lob + "/Inforce");
                };
                service.getAgentPolicies = function (lob) {
                    return portalApiGateway.getArray("/PolicyReport/" + lob + "/All");
                };
                service.getInformalPolicies = function () {
                    return portalApiGateway.getArray("/PolicyReport/Informal");
                };
                service.getPolicyAccountValues = function (policyGuid) {
                    return portalApiGateway.getArray("/PolicyReport/" + policyGuid + "/AccountValues");
                };
                service.getContracts = function () {
                    return portalApiGateway.getArray("/ContractReport/AgentContracts");
                };
                service.getSubAgents = function() {
                    return portalApiGateway.getArray("/SubAgents");
                };
                service.getSubAgentsPendingPolicies = function (subAgentGuid, lob) {
                    return portalApiGateway.getArray("/PolicyReport/SubAgents/" + subAgentGuid + "/Pending/" + lob);
                };
                service.getSubAgentsInforcePolicies = function(subAgentGuid, lob) {
                    return portalApiGateway.getArray("/PolicyReport/SubAgents/" + subAgentGuid + "/Inforce/" + lob);
                };
                service.getSubAgentsPolicies = function (subAgentGuid, lob) {
                    return portalApiGateway.getArray("/PolicyReport/SubAgents/" + subAgentGuid + "/All/" + lob);
                };
                service.getSubAgentsInformalPolicies = function(subAgentGuid) {
                    return portalApiGateway.getArray("/PolicyReport/SubAgents/" + subAgentGuid + "/Informal");
                };
                service.getSubAgentsPaidPolicies = function(subAgentGuid, lob, start, end) {
                    return portalApiGateway.getArray("/PolicyReport/SubAgents/" + subAgentGuid + "/Paid?start="
                        + start + "&end=" + end + "&lob=" + lob);
                };
                service.getPolicyDetail = function(policyGuid) {
                    return portalApiGateway.get("/PolicyReport/" + policyGuid);
                };
                service.getVariablePolicyDetail = function (policyGuid) {
                    return portalApiGateway.get("/PolicyReport/Variable/" + policyGuid);
                };
                service.getPoliciesRequirements = function (policyGuids) {
                    return portalApiGateway.getArray("/PolicyReport/PoliciesRequirements?policyGuids=" + policyGuids);
                };
                service.getVariablePoliciesRequirements = function (policyGuids) {
                    return portalApiGateway.getArray("/PolicyReport/Variable/PoliciesRequirements?policyGuids=" + policyGuids);
                };
                service.getInformalDetail = function (informalGuid) {
                    return portalApiGateway.get("/PolicyReport/Informal/" + informalGuid);
                };
                service.getStateAppointments = function (contractGuid, lineOfBusinessGuid) {
                    return portalApiGateway.get("/ContractReport/" + contractGuid + "/LineOfBusiness/" + lineOfBusinessGuid);
                };
                service.ExportPolicyReport = function (stage) {
                    return portalApiGateway.getFile("/PolicyReport/Export/" + stage);
                };
                service.ExportRequirementReport = function (requirements, stage) {
                    return portalApiGateway.getFilePost("/PolicyReport/Export/" + stage + "/Requirements", requirements);
                };
                service.ExportRequirementForLobReport = function (requirements, stage, lob) {
                    return portalApiGateway.getFilePost("/PolicyReport/Export/" + stage + "/Requirements/" + lob, requirements);
                };
                service.ExportSubAgentPolicyReport = function(params) {
                    return portalApiGateway.getFilePost("/PolicyReport/Export/SubAgent", params);
                };
                service.getPaidPolicies = function(start, end, lob) {
                    return portalApiGateway.getArray("/PolicyReport/Paid?start=" + start
                        + "&end=" + end + "&lob=" + lob);
                };
                service.getAgentsPendingPolicies = function (agentIds, lob) {
                    return portalApiGateway.post("/PolicyReport/Agents/Pending/" + lob, { AgentIds: agentIds });
                };
                service.getAgentsInforcePolicies = function (agentIds, lob) {
                    return portalApiGateway.post("/PolicyReport/Agents/Inforce/" + lob, { AgentIds: agentIds });
                };
                service.getAgentsPolicies = function (agentIds, lob) {
                    return portalApiGateway.post("/PolicyReport/Agents/All/" + lob, { AgentIds: agentIds });
                };
                service.getAgentsPaidPolicies = function (agentIds, lob, start, end) {
                    return portalApiGateway.post("/PolicyReport/Agents/Paid/" + lob + "?start="
                        + start + "&end=" + end, { AgentIds: agentIds });
                };
                service.getPolicyNotes = function (taskId) {
                    return portalApiGateway.get("/PolicyReport/Tasks/" + taskId + "/Notes");
                };
                service.getVariablePolicyNotes = function (taskId) {
                    return portalApiGateway.get("/PolicyReport/Variable/Tasks/" + taskId + "/Notes");
                };
                service.getAgentsInformalPolicies = function (agentIds) {
                    return portalApiGateway.post("/PolicyReport/Agents/Informal", { AgentIds: agentIds });
                };
                service.exportAgentsPolicies = function (model, stage) {
                    return portalApiGateway.getFilePost("/PolicyReport/Export/" + stage + "/Agents", model);
                };
                service.postPolicyFiles = function (policyGuid, formData) {
                    return portalApiGateway.postFile("/FileUpload/" + policyGuid, formData);
                };
                service.postNewPolicyFiles = function (formData) {
                    return portalApiGateway.postFile("/FileUpload/Policy", formData);
                };
                service.postPolicyTaskNotes = function (taskId, note) {
                    return portalApiGateway.post("/PolicyReport/Tasks/" + taskId + "/Notes", { Note: note });
                }
                service.exportContractReport = function (model) {
                    return portalApiGateway.getFilePost("/ContractReport/Export/", model);
                };
                return service;
            }
        ];
    }]);

})(window.app);